module.exports = __webpack_public_path__ + "static/media/cod-image-game.2979a5a5.svg";